import { EmblaCarouselType } from 'embla-carousel';
import { useCallback } from 'react';

import { styles } from './Thumb.styles';

type PropType = {
  selected: boolean;
  children?: React.ReactNode;
  onClick: () => void;
  className?: string;
};

export const useThumbActions = (emblaApi: EmblaCarouselType | undefined) => {
  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaApi) return;
      emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  return {
    onThumbClick
  };
};

export function Thumb({ selected, children, onClick, className }: PropType) {
  const slots = styles({});

  return (
    <div className={slots.slide({ className, selected: selected })}>
      <button
        onClick={onClick}
        type="button"
        className={slots.thumb()}
      >
        {children}
      </button>
    </div>
  );
}
